const parse = require('./parse')
const valid = (version, options) => {
  const v = parse(version, options)
  return v ? v.version : null
}
module.exports = valid



//////////////////
// WEBPACK FOOTER
// ./~/semver/functions/valid.js
// module id = 2194
// module chunks = 0